import merge from 'lodash.merge';
import Parser from 'html-react-parser';
import * as resetTemplate from '../conf/wording.conf';
import * as createTemplate from '../conf/wording.create.conf';

class WordingService {
  constructor() {
    /**
     * The default wording use case
     * @type {string}
     */
    this.dictionary = {};
    this.setDictionary('reset');
  }

  setDictionary(useCase) {
    switch (useCase) {
      case 'create':
        // Create hard copy of original dictionary and work with them because merge() work by ref
        const resetTmp = JSON.parse(JSON.stringify(resetTemplate));
        const createTmp = JSON.parse(JSON.stringify(createTemplate));
        this.dictionary = merge(resetTmp, createTmp);
        break;
      default:
        this.dictionary = { ...resetTemplate };
        break;
    }
  }

  /**
   * Return the correct wording dictionary
   * @param type
   * @param wording
   * @param noParser
   * @return {*}
   */
  getWording(type, wording, noParser = false) {
    if (noParser) {
      return this.dictionary[type][wording];
    }
    return Parser(this.dictionary[type][wording]);
  }
}

export default new WordingService();
